import { z } from 'zod';
import { fetchJson } from '@pkgs/api/utils/fetch';

export function validateEmail(email: string): boolean {
  const schema = z.string().email();
  return schema.safeParse(email).success;
}

export async function validateFriendlyCaptcha(token: string) {
  const friendlyCaptchaResponse = await fetchJson<{ success: boolean }>('https://api.friendlycaptcha.com/api/v1/siteverify', {
    body: JSON.stringify({
      secret: process.env.FRIENDLY_CAPTCHA_SECRET_KEY,
      siteKey: process.env.NEXT_PUBLIC_FRIENDLY_CAPTCHA_SITE_KEY,
      solution: token,
    }),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });

  const { success } = friendlyCaptchaResponse;

  return success;
}

export const validateRangeFieldNumber = (value: string): boolean => {
  const numberRegex = /^[1-9]\d*$/;
  return numberRegex.test(value.toString());
};
